module.exports = __webpack_public_path__ + "static/media/tickChecked.cc5f6302.svg";